var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"knowledge-asset-tag bg-gray-100",attrs:{"pill":"","variant":"light"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }